import {
  MAGAZINE_CREATE, MAGAZINE_CREATE_FAILURE, MAGAZINE_CREATE_SUCCESS
} from './mutation-types'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    [MAGAZINE_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/magazines', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(MAGAZINE_CREATE_FAILURE, res.data)
            } else {
              commit(MAGAZINE_CREATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [MAGAZINE_CREATE_FAILURE] (state, data) {
      console.log('MAGAZINE_CREATE_FAILURE')
    },
    [MAGAZINE_CREATE_SUCCESS] (state, data) {
      console.log('MAGAZINE_CREATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/magazine-new.js